/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type for the choice info, e.g. user groups filtering active
 * @export
 */
export const ChoiceInfoTypeConstants = {
    UserGroupsFilterActive: 'UserGroupsFilterActive'
} as const;
export type ChoiceInfoTypeConstants = typeof ChoiceInfoTypeConstants[keyof typeof ChoiceInfoTypeConstants];


export function ChoiceInfoTypeConstantsFromJSON(json: any): ChoiceInfoTypeConstants {
    return ChoiceInfoTypeConstantsFromJSONTyped(json, false);
}

export function ChoiceInfoTypeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChoiceInfoTypeConstants {
    return json as ChoiceInfoTypeConstants;
}

export function ChoiceInfoTypeConstantsToJSON(value?: ChoiceInfoTypeConstants | null): any {
    return value as any;
}

